import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "stroke-width": "1.5",
      "stroke-miterlimit": "10",
      d: "M7.87 21.21c2.04 0 3.68-1.65 3.68-3.68 0-2.04-1.65-3.68-3.68-3.68-2.04 0-3.68 1.65-3.68 3.68a3.67 3.67 0 0 0 3.68 3.68zM11.55 17.53V4.66M13.96 2.91l4.06 1.36c.99.33 1.79 1.44 1.79 2.48v1.08c0 1.41-1.09 2.19-2.41 1.73l-4.06-1.35c-.99-.33-1.79-1.44-1.79-2.48V4.66c0-1.39 1.08-2.19 2.41-1.75z"
    }, null, -1 /* CACHED */)
  ]))]))
}
export default { render: render }